import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="bg-navy-dark py-16 px-4 relative overflow-hidden" data-id="element-152">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-white/5 rounded-full blur-[150px] pointer-events-none" data-id="element-153"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-154">
        <div className="text-center mb-10" data-id="element-155">
          <h2 className="text-lg md:text-2xl font-heading font-bold mb-4 flex items-center justify-center tracking-wide text-white" data-id="element-156">
            Launch price ends soon.
          </h2>
          <p className="text-white/80 font-bold mb-2" data-id="element-157">This offer ends in:</p>
          <Countdown data-id="element-158" />
          <div className="mt-4" data-id="element-159">
            <p className="text-white flex items-center justify-center text-sm md:text-base font-bold bg-black/20 inline-flex px-4 py-2 rounded-full border border-white/20" data-id="element-160">
              <span className="text-gold mr-2" data-id="element-161">⚠️</span> When the timer ends,
              the price returns to $97. Lock in the launch price today.
            </p>
          </div>
          <div className="mt-4 max-w-xs mx-auto" data-id="element-162">
            <div className="flex justify-between text-xs text-white/80 font-bold mb-1" data-id="element-163">
              <span data-id="element-164">Launch-price spots</span>
              <span data-id="element-165">88% claimed</span>
            </div>
            <div className="w-full bg-white/20 rounded-full h-2" data-id="element-166">
              <div className="bg-gold h-2 rounded-full" style={{
              width: '88%'
            }} data-id="element-167"></div>
            </div>
          </div>
        </div>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-168">
          <motion.div whileHover={{
          y: -8
        }} className="bg-navy rounded-2xl p-8 md:p-12 border-4 border-orange flex flex-col h-full shadow-2xl relative" data-id="element-169">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-orange text-white font-bold px-4 py-1 rounded-full text-sm shadow-md whitespace-nowrap" data-id="element-170">
              ⭐ Most Popular Choice
            </div>
            <div className="text-center mb-6 mt-2" data-id="element-171">
              <h3 className="text-2xl md:text-3xl font-heading font-black text-white mb-2" data-id="element-172">
                Kit The Focused Mindset™ — The Ultimate Family Bundle
              </h3>
              <p className="text-muted font-bold text-sm md:text-base mb-6" data-id="element-173">
                For parents of kids ages 3–12 · Instant PDF · Print at home
              </p>
              <div className="bg-black/20 rounded-xl py-5 px-6 text-left border border-white/10" data-id="element-174">
                <ul className="space-y-3" data-id="element-175">
                  <li className="flex items-start text-sm md:text-base text-ink font-medium" data-id="element-176">
                    <span className="text-green mr-2 font-bold" data-id="element-177">✓</span> 6
                    Complete Brain Training Volumes (300+ printable activities)
                  </li>
                  <li className="flex items-start text-sm md:text-base text-ink font-medium" data-id="element-178">
                    <span className="text-green mr-2 font-bold" data-id="element-179">✓</span> Full
                    progressive system — ages 3 to 12
                  </li>
                  <li className="flex items-start text-sm md:text-base text-ink font-medium" data-id="element-180">
                    <span className="text-green mr-2 font-bold" data-id="element-181">✓</span> 5 Bonus
                    Guides Included (worth $85+)
                  </li>
                  <li className="flex items-start text-sm md:text-base text-ink font-medium" data-id="element-182">
                    <span className="text-green mr-2 font-bold" data-id="element-183">✓</span>{' '}
                    Lifetime Access — pay once, keep forever
                  </li>
                  <li className="flex items-start text-sm md:text-base text-ink font-medium" data-id="element-184">
                    <span className="text-green mr-2 font-bold" data-id="element-185">✓</span> Print
                    for ALL your children — no limits
                  </li>
                  <li className="flex items-start text-sm md:text-base text-ink font-medium" data-id="element-186">
                    <span className="text-green mr-2 font-bold" data-id="element-187">✓</span> Black &
                    white version included to save on ink
                  </li>
                </ul>
              </div>
            </div>

            <div className="text-center mb-8 flex-grow" data-id="element-188">
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-189">
                <p className="line-through text-lg md:text-xl text-muted font-medium" data-id="element-190">
                  $97
                </p>
                <span className="bg-softred text-white text-xs font-bold px-2 py-1 rounded" data-id="element-191">
                  🔥 80% OFF
                </span>
              </div>
              <div className="flex items-start justify-center" data-id="element-192">
                <span className="text-2xl md:text-3xl text-white mt-1 mr-1 font-bold" data-id="element-193">
                  $
                </span>
                <span className="text-5xl md:text-7xl font-heading font-black text-white" data-id="element-194">
                  19
                </span>
                <span className="text-base md:text-2xl text-white mt-auto mb-2 ml-2 font-bold" data-id="element-195">
                  USD
                </span>
              </div>
              <p className="text-sm md:text-base font-bold text-green max-w-md mx-auto mt-2" data-id="element-196">
                You save $78 today
              </p>
              <p className="text-xs text-muted font-medium mt-1" data-id="element-197">
                💳 One-time · Pay in your local currency
              </p>
            </div>

            <a href="https://thefocusedmindset.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="block w-full bg-orange hover:bg-orange-dark text-white font-heading font-bold py-5 px-6 rounded-full transition-all text-center text-base md:text-lg shadow-lg hover:scale-[1.02] active:scale-95 mb-3" data-id="element-198">
              🚀 YES, I WANT THE COMPLETE KIT
            </a>
            <div className="flex justify-center items-center gap-4 text-xs font-bold text-muted uppercase tracking-wider" data-id="element-199">
              <span className="flex items-center" data-id="element-200">
                <span className="text-orange mr-1" data-id="element-201">⚡</span> Instant access in 5
                minutes
              </span>
              <span className="flex items-center" data-id="element-202">
                <span className="text-green mr-1" data-id="element-203">🔒</span> Secure SSL checkout
              </span>
            </div>
          </motion.div>
        </div>

        <div className="flex flex-col items-center justify-center gap-4 text-sm text-white font-medium bg-black/20 py-6 px-8 rounded-2xl border border-white/20 max-w-4xl mx-auto shadow-sm text-center" data-id="element-204">
          <div className="flex items-center justify-center" data-id="element-205">
            <Shield className="w-5 h-5 mr-2 text-gold" data-id="element-206" /> Backed by our 7-Day
            Zero-Risk Guarantee — refunded in full, no questions asked.
          </div>
          <div className="flex items-center justify-center gap-4 text-white/80" data-id="element-207">
            <span data-id="element-208">⭐ 4.9/5 Reviews</span>
            <span data-id="element-209">·</span>
            <span data-id="element-210">🌍 Families Worldwide</span>
          </div>
        </div>
      </div>
    </section>;
}